import { render, staticRenderFns } from "./DodajProizvode.vue?vue&type=template&id=5765dcfa&"
import script from "./DodajProizvode.vue?vue&type=script&lang=js&"
export * from "./DodajProizvode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports